<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="headline">Inventory</h5>
      <button class="btn btn-outline-info btn-sm shadow-none" @click="$emit('store-button-click')" v-blur-on-click>
        Add Stock
      </button>
    </div>
    <ul class="list-group" v-if="items.length !== 0">
      <li
        v-for="(item, i) in items"
        :key="i"
        class="list-group-item d-flex justify-content-between align-items-center stock-listing__item"
        @click="$emit('item-selected', item)"
      >
        <span>
          <span class="stock-listing__amount">{{ item.amount }}x in</span>
          <ShelfBadge :label="item.shelfSpaceId" />
        </span>
        <ExpiryDateBadge v-if="item.expiryDate" :expiryDate="item.expiryDate" show="date" />
      </li>
    </ul>
    <div class="alert alert-warning" role="alert" v-else>
      No Inventory Found
    </div>
  </div>
</template>

<script>
import ShelfBadge from '@/components/ShelfBadge'
import ExpiryDateBadge from '@/components/ExpiryDateBadge'

export default {
  components: { ExpiryDateBadge, ShelfBadge },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.stock-listing {
  &__item {
    font-size: 1.25rem;
    padding: 1rem;
  }

  &__amount {
    display: inline-block;
    min-width: 5rem;
    padding-right: 0.5rem;

    text-align: right;
  }
}
</style>
